import React, { useContext, useEffect } from 'react'
import { last } from 'lodash'
import { ChatContext } from '~/service/chatConn'
import { Chat, Message } from '~/service/chatConn/types'
import Scrollbar from 'react-scrollbars-custom'
import classNames from 'classnames'

const List: React.FC = ({}) => {
  const { chats } = useContext(ChatContext)
  const chatsActive = chats.filter(chat => !chat.stopped)
  const chatsEnded = chats.filter(chat => chat.stopped)

  return (
    <div className="chat-list">
      <Scrollbar disableTracksWidthCompensation={true} onUpdate={state => {}}>
        <ListPart
          label={intl.formatMessage({ id: 'chat / list / header / active ' })}
          chats={chatsActive}
          // notificationOnEmpty
        />

        <ListPart
          label={intl.formatMessage({ id: 'chat / list / header / ended ' })}
          chats={chatsEnded}
        />
      </Scrollbar>
    </div>
  )
}

export default List

//

type ListPartProps = {
  label?: string
  chats: Chat[]
  // notificationOnEmpty?: boolean
}

const ListPart: React.FC<ListPartProps> = ({
  label,
  chats,
  // notificationOnEmpty,
}) => {
  // if (!chats.length /* && !notificationOnEmpty*/) {
  //   return null
  // }

  // if (!chats.length) {
  //   return (
  //     <div className="notification">
  //       {intl.formatMessage({ id: 'chat / list / empty' })}
  //     </div>
  //   )
  // }

  return (
    <>
      {label && <div className="chat-list-header">{label}</div>}

      {!chats.length ? (
        <div className="chat-list-item-empty">
          <span className="fat fa-messages"></span>
          <span className="chat-list-item-empty-info">
            {intl.formatMessage({ id: 'chat / list / empty' })}
          </span>
        </div>
      ) : (
        <>
          {chats.map(chat => (
            <ListItem chat={chat} key={chat.id} />
          ))}
        </>
      )}
    </>
  )
}

//

type ListItemProps = {
  chat: Chat
}

const ListItem: React.FC<ListItemProps> = ({ chat }) => {
  const { activateChat, removeChat, activeChatMaybe } = useContext(ChatContext)

  const lastMessage = last(chat.messages) as Message

  return (
    <>
      <div
        className={classNames('chat-list-item', {
          'is-active': activeChatMaybe && activeChatMaybe.id == chat.id,
        })}
        onClick={() => activateChat(chat.id)}
      >
        <figure className="chat-list-item-avatar">
          <img src={chat.client.avatar} />
        </figure>

        <div className="chat-list-item-main">
          <div className="chat-list-item-main-top">
            <div className="chat-list-item-name">{chat.client.name}</div>

            <div className="chat-list-item-count">
              <div>{chat.unread > 0 ? chat.unread : null}</div>
            </div>

            {chat.stopped && (
              <button
                className="chat-list-item-remove"
                onClick={() => removeChat(chat.id)}
              >
                <span className="icon">
                  <span className="fa fa-times" />
                </span>
              </button>
            )}
          </div>

          <div className="chat-list-item-message">
            {lastMessage.previewContent}
          </div>
        </div>
      </div>
    </>
  )
}
